// components
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';

type ExteriorInteriorColorProps = {
    exteriorColor: string;
    interiorColor: string;
};

export const ExteriorInteriorColor = ({ exteriorColor, interiorColor }: ExteriorInteriorColorProps) => {
    return (
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
            <Typography variant="body-md" color="sem.color.on-surface.muted" tag="span">
                Ext/Int Color:
            </Typography>
            <Typography variant="body-md" tag="span">
                {exteriorColor || '—'}
                {interiorColor ? `/${interiorColor}` : '/—'}
            </Typography>
        </Box>
    );
};
